'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Alert } from '@workspace/ui/components/custom/alert';
import { Tooltip, TooltipContent, TooltipTrigger } from '@workspace/ui/components/tooltip';
import { cn } from '@workspace/ui/lib';
import type { ReactNode } from 'react';
import {
  CARD_MAINTENANCE_DESCRIPTION,
  CARD_MAINTENANCE_DETAILS,
  CARD_MAINTENANCE_DISABLED_MESSAGE,
  CARD_MAINTENANCE_TITLE,
  IS_EPS_CARD_MAINTENANCE_ACTIVE,
} from '@/lib/card-maintenance';

interface CardMaintenanceAlertProps {
  className?: string;
  /** Wallet card container: title only. Card details page: full copy. */
  titleOnly?: boolean;
}

export function CardMaintenanceAlert({ className, titleOnly = false }: CardMaintenanceAlertProps) {
  if (!IS_EPS_CARD_MAINTENANCE_ACTIVE) {
    return null;
  }

  return (
    <Alert
      variant="warning"
      className={className}
      descriptionClassName={titleOnly ? undefined : 'flex-col! items-start! gap-2'}
      description={
        titleOnly ? (
          <p className="text-grey-1000 text-sm font-bold dark:text-neutral-100">
            {CARD_MAINTENANCE_TITLE}
          </p>
        ) : (
          <div className="flex flex-col gap-2">
            <p className="text-grey-1000 text-sm font-bold dark:text-neutral-100">
              {CARD_MAINTENANCE_TITLE}
            </p>
            <p className="text-grey-700 dark:text-grey-300 text-sm">
              {CARD_MAINTENANCE_DESCRIPTION}
            </p>
            <p className="text-grey-700 dark:text-grey-300 text-sm">{CARD_MAINTENANCE_DETAILS}</p>
          </div>
        )
      }
    />
  );
}

interface CardMaintenanceTooltipProps {
  children: ReactNode;
  className?: string;
}

export function CardMaintenanceTooltip({ children, className }: CardMaintenanceTooltipProps) {
  if (!IS_EPS_CARD_MAINTENANCE_ACTIVE) {
    return children;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn('inline-flex', className)}>{children}</span>
      </TooltipTrigger>
      <TooltipContent>
        <p>{CARD_MAINTENANCE_DISABLED_MESSAGE}</p>
      </TooltipContent>
    </Tooltip>
  );
}
